@if (location) {

  <!-- Exclude controls -->
  <div class="row align-items-end">
    <div class="col-md-5">
      <label><strong>{{'EXCLUDE_DEVICES_LABEL' | translate}}</strong></label>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'SELECT_DEVICES' | translate}}</mat-label>
        <mat-select multiple [(ngModel)]="selectedDeviceIds" (ngModelChange)="onSelectionChange()">
          <mat-select-trigger>
            {{ realSelectedDevices.length === availableDevices.length && availableDevices.length > 0
                ? ('ALL' | translate)
                : realSelectedDevices.map(d => d.name).join(', ') }}
          </mat-select-trigger>
          <mat-option value="__select_all__">
            <strong>{{'SELECT_ALL' | translate}}</strong>
          </mat-option>
          @for (dev of availableDevices; track dev.id) {
            <mat-option [value]="dev.id">
              {{dev.name}} ({{dev.id}})
              @if (isExcluded(dev.id)) {
                <i class="fa-solid fa-ban fa-xs ml-2" title="{{'EXCLUDED' | translate}}"></i>
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-md-5">
      <label><strong>{{'EXCLUSION_REASON' | translate}}</strong></label>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'SELECT_REASON' | translate}}</mat-label>
        <mat-select [(ngModel)]="selectedReason">
          @for (opt of reasonOptions; track opt.value) {
            <mat-option [value]="opt.value">{{opt.key | translate}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row mb-1">
    <div class="col-md-10">
      <p class="text-muted small mb-0">{{'EXCLUSION_INFO_TEXT' | translate}}</p>
    </div>
  </div>

  <div class="row align-items-end mb-3">
    <div class="col-md-3 mb-3">
      <button class="btn btn-primary w-100"
        [disabled]="selectedDeviceIds.length === 0 || selectedReason === null"
        (click)="excludeDevices()">
        {{'EXCLUDE_DEVICES' | translate}}
      </button>
    </div>
  </div>

  @if (excludeSuccess) {
    <div class="alert alert-success">{{'EXCLUDE_DEVICES_SUCCESS' | translate}}</div>
  }
  @if (excludeError) {
    <div class="alert alert-danger">{{'ERROR' | translate}}</div>
  }

  <!-- Excluded devices table -->
  @if (excludedDevices.length > 0) {
    <h6 class="mt-2"><strong>{{'EXCLUDED_DEVICES' | translate}}</strong></h6>
    <table class="table table-hover">
      <thead>
        <tr>
          <th>{{'DEVICE_NAME' | translate}}</th>
          <th>ID</th>
          <th>{{'EXCLUSION_REASON' | translate}}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (dev of excludedDevices; track dev.id) {
          <tr>
            <td>{{dev.name}}</td>
            <td>{{dev.id}}</td>
            <td>{{getExclusionReasonLabel(dev.exclusionReason) | translate}}</td>
            <td>
              <button type="button" class="btn btn-link p-0 border-0 shadow-none"
                title="{{'REMOVE_EXCLUSION' | translate}}"
                (click)="removeExclusion(dev)">
                <i class="fa-solid fa-xmark fa-xl text-danger"></i>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
      <button type="button" class="btn btn-outline-danger btn-sm mb-3"
        (click)="removeAllExclusions()">
        <i class="fa-solid fa-ban fa-sm mr-2"></i>{{'REMOVE_ALL_EXCLUSIONS' | translate}}
      </button>
  } @else {
    <div class="text-muted">{{'NO_EXCLUDED_DEVICES' | translate}}</div>
  }
}
